import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
  // slider
  const backgroundImage = '.slider-bg',
        backgroundImageOption = {
          type: 'fade',
          rewind: true,
          speed: 2500,
          arrows: false,
          pagination: false,
          easing: 'ease-in-out',
          drag: false,
          autoplay: true,
          interval: 5000,
          pauseOnHover: false,
          slideFocus: true,
        };

  const title = '.slider-title',
        titleOption = {
          type: 'fade',
          rewind: true,
          speed: 2000,
          arrows: false,
          pagination: false,
          easing: 'cubic-bezier(0.33, 1, 0.68, 1) 1600ms',
          drag: false,
          autoplay: true,
          pauseOnHover: false,
          slideFocus: true,
        };

  const backgroundImageSplide = new Splide(backgroundImage, backgroundImageOption);
  const titleSplide = new Splide(title, titleOption);

  backgroundImageSplide.sync(titleSplide);
  backgroundImageSplide.mount();
  titleSplide.mount();
  setTimeout(()=>{
    backgroundImageSplide.go('>');
  }, 2500);
});
